const API_BASE_URL = "https://sppipejc.iservicex.in";
const REPORT_BASE_URL = "https://rmpapi.iworkx.in";

const api = {
    get: async (endpoint, params = {}, baseUrl = API_BASE_URL) => {
        const url = new URL(`${baseUrl}/${endpoint}`);
        Object.keys(params).forEach((key) =>
            url.searchParams.append(key, params[key])
        );

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const json = await response.json();

            if (Object.keys(json).length === 1) {
                const dataKey = Object.keys(json)[0];
                return json[dataKey];
            }
            return json;
        } catch (error) {
            console.error("API GET Error:", error);
            throw error;
        }
    },

    post: async (endpoint, body, baseUrl = API_BASE_URL) => {
        try {
            const response = await fetch(`${baseUrl}/${endpoint}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const json = await response.json();

            if (
                Object.keys(json).length === 1 &&
                Object.keys(json)[0].endsWith("js")
            ) {
                return json[Object.keys(json)[0]];
            }

            return json;
        } catch (error) {
            console.error("API POST Error:", error);
            throw error;
        }
    },

    getJobcardList: (user) => api.get("JCTrackingGen", { User: user }),
    getJobcardTracking: (user, noLabel, idsOrDates) => {
        const currentDate = new Date().toISOString().split("T")[0];
        let params = { User: user, Jcid: 0, Cpid: 0, FromDate: currentDate, ToDate: currentDate };

        if (noLabel === "JcNo") {
            params.Jcid = idsOrDates.join(",");
        } else if (noLabel === "InvNo") {
            params.Cpid = idsOrDates.join(",");
        } else if (noLabel === "DateWise") {
            params.FromDate = idsOrDates.fromDate || currentDate;
            params.ToDate = idsOrDates.toDate || currentDate;
            params.Jcid = 0;
            params.Cpid = 0;
        }
        return api.get("JobcardTracking", params);
    },

    CheckLogin: (BodyParam) => api.post("CheckLogin", BodyParam),

    loginUser: async (username, password) => {
        try {
            const response = await fetch(`${API_BASE_URL}/CheckLogin`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    UsrName: username,
                    UsrPwd: password,
                    SessionId: "1234",
                }),
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return await response.json();
        } catch (error) {
            console.error("Login API Error:", error);
            throw error;
        }
    },

    submitInvoiceMappingAlloted: async (payload) => {
        try {
            const response = await fetch(`${API_BASE_URL}/InvoiceMappingAllotedpost`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return await response.json();
        } catch (error) {
            console.error("InvoiceMappingAlloted POST Error:", error);
            throw error;
        }
    },

    getHtmlReport: async (grnId) => {
        return api.get(
            "GetHtmlReportString",
            {
                _mdlid: "GRNEntry_MMI_TXp_Prj.GRNEntry_MMI_TXp_Cls.",
                _User: "admin",
                _primeid: grnId,
                _FilterCondition: grnId,
                _LotId: 0,
                _HTMLFileName: "GRN2 Report",
                databaseKey: "ERPSPPIPE",
            },
            REPORT_BASE_URL
        );
    },

    getIndividualData: async (grnId) => {
        return api.get(
            "GetIndividualData",
            {
                MdlId: "GIPEntry_TXp_Prj.GIPEntry_TXp_Cls.INWARD",
                ID: grnId,
                UserId: 1,
                databaseKey: "ERPSPPIPE",
            },
            REPORT_BASE_URL
        );
    },

    getJCTrackingRights: (user) => api.get("JCTrackingRights", { User: user }),
    JCInvoiceMappingList: (user, invDate) => api.get("JCInvoiceMappingList", { User: user, InvDate: invDate }),
    JCInvoiceMappingavailableList: (user, FGitemId) => api.get("JCInvoiceMappingavailableList", { User: user, FGitemId: FGitemId }),
 insertPdfReceiptData: async (userName, payload) => {
        const url = `${API_BASE_URL}/InsertPdfReceiptData?userName=${userName}`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            let data = null;
            try {
                data = await response.json();
            } catch {
                data = null;
            }
            if (!response.ok) {
                const error = new Error(`HTTP error! status: ${response.status}`);
                error.status = response.status;
                error.data = data;
                throw error;
            }
            return data;
        } catch (error) {
            console.error("InsertPdfReceiptData API Error:", error);
            throw error;
        }
    },
};

export default api;
